/**
 * useA2hsGuide — "홈 화면에 추가" 안내 모달을 어디서든 열기(내 계정 › 기기관리 [추가] 등).
 * useMyAccountModal 과 같은 모듈 상태 + useSyncExternalStore 패턴. Layout 의 <A2hsPrompts /> 가 한 번만 그린다.
 */
import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

function emit(next: boolean) {
  open = next;
  listeners.forEach((l) => l());
}

export function openA2hsGuide(): void {
  emit(true);
}
export function closeA2hsGuide(): void {
  emit(false);
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
function snapshot() {
  return open;
}

export function useA2hsGuide(): boolean {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
